import { joiResolver } from "@hookform/resolvers/joi";
import { DmcMasterApi } from "api/dmcMaster.api";
import { activitySchema } from "commonFnBcode/joiSchemas/Dmc.schemas";
import { FullScreenLoader } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/components/FullScreenLoader";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { CityDBSearch } from "../../components/afterLogin/dashboard/staffDashboard/master/CityDBSearch";
import { CreateActivityText } from "../../dmcMaster/activity/CreateActivityHelper";

type FormValues = {
  id?: number;
  name: string;
  description: string;
  cityId: number;
  activityId?: number;
};

export enum ActivityTypeEnum {
  TRANSFER = "transfer",
  SIGHT = "sightseeing",
  MEAL = "meal",
}

export const CreateNewActivity: React.FC<{
  isModalOpen: boolean;
  handleModalClose: () => void;
  activityId?: number;
}> = (props) => {
  const [prevActivityState, setPrevActivityState] = useState<any>();
  const [loadingState, setLoadingState] = useState<boolean>(false);

  const {
    handleSubmit,
    register,
    watch,
    formState,
    control,
    setError,
    clearErrors,
    setValue,
  } = useForm<FormValues>({
    resolver: joiResolver(activitySchema),
    defaultValues: {
      id: undefined,
      description: "",
      name: "",
      // type: ActivityTypeEnum.TRANSFER,
      cityId: undefined,
    },
  });
  const errors = formState.errors;

  const getActivities = async () => {
    const activityDetail = await DmcMasterApi.getActivities({
      id: props.activityId,
    });
    if (activityDetail.result.length === 1) {
      const activity = activityDetail.result[0];
      setPrevActivityState(activity);
      setValue("id", activity.id);
      setValue("name", activity.name);
      setValue("description", activity.description);
      setValue("cityId", activity.cityId);
    }
  };

  useEffect(() => {
    if (props.activityId) {
      getActivities();
      setValue("id", props.activityId || undefined);
    }

    return () => {
      setValue("id", undefined);
    };
  }, [props.activityId]);

  const onSubmit = async (data) => {
    setLoadingState(true);
    try {
      const saveActivityRes = await DmcMasterApi.saveActivity(data);
      if (saveActivityRes.success) {
        toast.success("Activity Saved Successfully");
        props.handleModalClose();
      } else {
        throw new Error(saveActivityRes.data.errorMessage);
      }
    } catch (err: any) {
      toast.error(err.message);
    }
    setLoadingState(false);
  };

  const activityWatch = watch();

  return (
    <div>
      <FullScreenLoader show={loadingState} />
      {/* create customer modal  starts */}
      <Modal show={props.isModalOpen} onHide={props.handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            {activityWatch.id && activityWatch.id > 0 ? "Edit " : "Create New "}
            Activity
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className="row">
              <CreateActivityText
                label="Name"
                register={register("name")}
                type="text"
                error={errors.name}
              />

              <CityDBSearch
                onSelect={(cityId) => {
                  setValue("cityId", cityId);
                }}
                inputValue={
                  prevActivityState?.city
                    ? `${prevActivityState?.city.city}, ${prevActivityState?.city.country}`
                    : undefined
                }
                label="Select City"
                error={errors.cityId?.message}
              />
              <CreateActivityText
                label="Description"
                register={register("description")}
                type="text"
                error={errors.description}
              />
              <div className="row">
                <div className="col-12">
                  <button
                    className="btn btn-primary mt-4"
                    onClick={handleSubmit(onSubmit)}
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};
